import React, { useEffect, useState } from "react";
import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import {
    SetTheBlacklistCreateActions,
  SetTheBlacklistRetrieveActions,
  SetTheBlacklistEditsActions,
} from "../../../Redux/Slice";
const BlackListCeatePoup = (props) => {
  const { show, setShow, currentPage, EditId, selectVal, datas , ActiveFor , 

    Emp_old ,
    client_id_sfrom ,
    searchemp ,
    page_size_approved,
    Count_of_block,
    black_list } = props;
  let [nameList, setOptions] = useState([]);
  const [multiselect, setMuliselect] = useState([]);
  const [stateerror, setStateError] = useState("");
  const [States, setState] = useState([]);
  const state = useSelector((state) => state);
  const form_data = new FormData();
  const initialState = {
    reason_decline: "",
    reason: "",
    user_id: "",
    request_type: ActiveFor == 1 ? "request" : "cancel",
  };
  const [data, setdatas] = useState(initialState);

  useEffect(() => {
    if (EditId != "") {
      dispatch(SetTheBlacklistRetrieveActions({ EditId }));
    }
  }, []);

  const [support_doc, setsupportdoc] = useState();
  const [reasonerr, setReasonerr] = useState("");

  const dispatch = useDispatch();

  //   console.log(
  //     state.ClientBranchIDs,
  //     "ClientBranchIDs",
  //     state.ClientBranchIDs.UserObject
  //   );
  const HandleChanges = (e) => {
    setdatas((prev) => {
      return {
        ...prev,
        [e.target.name]: e.target.value,
      };
    });
  };

  useEffect(() => {
    /// console.log(state.BlacklistRetrieveCall.Blacklistdataretrieve, "datas");
    if (EditId != undefined || EditId != "") {
      setdatas({
        ...data,
        reason: state.BlacklistRetrieveCall.Blacklistdataretrieve.reason,
      });
    }
  }, [state.BlacklistRetrieveCall.Blacklistdataretrieve]);

  const HandleSubmit = () => {
    var a = 0;
    if (EditId == undefined || EditId == "") {
      form_data.append(
        "data",
        JSON.stringify({
          request_type: data.request_type,
          reason: data.reason,
          user_id: state.ClientBranchIDs.UserObject.value,
        })
      );
      if (data.reason == "") {
        setReasonerr("*reason is required");
        a = 1;
      }
      if (a == 0) {
        const payload = {
          form_data: {
            request_type: data.request_type,
          reason: data.reason,
          user_id: state.ClientBranchIDs.UserObject.value,
          },
          data: datas,
          selectVal: selectVal,
          from_client: state.ClientBranchIDs.SingelEmployeelistes,
          user: state.ClientBranchIDs.EmployeeDetailsProfile,
          reason_decline:data.reason_decline,
          count:2,
          user_id:state.ClientBranchIDs.UserObject.value , 

          //
             
                    Emp_old:Emp_old,
          page_size_approved:page_size_approved,
          searchemp:searchemp,
          client_id_sfrom:client_id_sfrom,
          Count_of_block:Count_of_block ? Count_of_block : "2",
black_list:black_list,
currentPage:currentPage,
        };

        dispatch(
            SetTheBlacklistCreateActions(payload, props.setShow(false), )
        );
      }
    }
  };

  const HandleEdits = () => {
    if (EditId != undefined && EditId != "") {
      var a = 0;

      form_data.append(
        "data",
        JSON.stringify({
          request_type: data.request_type,
          reason: data.reason,
          user_id: state.ClientBranchIDs.UserObject.value,
          reason_decline:data.reason_decline
        })
      );

      if (data.reason == "") {
        setReasonerr("*reason is required");
        a = 1;
      }
      if (a == 0) {
        const payload = {
          form_data: form_data,
          data: datas,
          selectVal: selectVal,
          from_client: state.ClientBranchIDs.SingelEmployeelistes,
          user: state.ClientBranchIDs.EmployeeDetailsProfile,
          EditId: EditId,
         
         
        };

        dispatch(SetTheBlacklistEditsActions(payload, props.setShow(false)));
      }
    }
  };

  return (
    <>
      <div className="RoleCreatePopup">
        <div className="BeforePopUp" style={{width:"100%"}}>
          <div className="RolePopups" style={{ width: "40%" }}>
            <div className="asds">
              <div class="ModalHeader">
                {EditId == undefined || EditId == "" && ActiveFor == 1 ? (
                  <span className="UserCreate" style={{color:"#fff"}}>Block  </span>
                ) : (
                  <span> Block  </span>
                )}


                <div className="CloseIcon" onClick={(e) => setShow(false)}>
                  <CloseOutlinedIcon />
                </div>
              </div>

              <from
                class="row g-3 form-fields-wrapper"
                style={{ padding: "20px" }}
              >
                <div className="col field-div" id="RegionCreatePOPUP">
                  <label for="validationCustom01" class="form-label">
                    User<span style={{ color: "red" }}>*</span>
                  </label>

                  <Select
                    className="Selects"
                    styles={{
                      position: "relative",
                      top: "60px",
                      padding: "70vh",
                    }}
                    value={state.ClientBranchIDs.UserObject}
                  />
                </div>

                <div class="col field-div">
                  <label
                    for="validationCustom01"
                    class="form-label"
                    style={{ fontSize: "15px" }}
                  >
                    Reason  For Block<span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    value={data.reason}
                    autoComplete="off"
                    onChange={(e) => {
                      HandleChanges(e);
                      setReasonerr("");
                    }}
                    required
                    name="reason"
                    style={{
                      padding: "15px",
                    }}
                  ></input>
                  <p style={{ color: "red", marginTop: "5px" }}>{reasonerr}</p>
                </div>

                {/* <div class="col-6 field-div">
                  <label
                    for="validationCustom01"
                    class="form-label"
                    style={{ fontSize: "15px" }}
                  >
                    Reason Decline <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    value={data.reason_decline}
                    autoComplete="off"
                    onChange={(e) => {
                      HandleChanges(e);
                      setReasonerr("");
                    }}
                    required
                    name="reason_decline"
                    style={{
                      padding: "15px",
                    }}
                  ></input>
                  <p style={{ color: "red", marginTop: "5px" }}>{reasonerr}</p>
                </div> */}


                <div
                  className="RoleButton"
                  style={{
                    display: "flex",
                    gap: "15px",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <button
                    class="btn  SaveBtn"
                    type="submit"
                    onClick={(e) => {
                      HandleSubmit(e);

                      HandleEdits(e);
                    }}
                  >
                    Submit 
                  </button>

                  <button class="btn CancelBtn" onClick={(e) => setShow(false)}>
                    Cancel
                  </button>
                </div>
              </from>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BlackListCeatePoup;
